export interface ICustomerNoteModel {
  title: string;
  body: string;
  type: string;
  isCritical: boolean;
  customerNumber: string;
}

export class CustomerNoteModel implements ICustomerNoteModel {
  title: string;
  body: string;
  type: string;
  isCritical: boolean;
  customerNumber: string;
}
